<template>
  <div id="app" :style="'background-size:'+sz">
<!--    <img style="position:fixed;left: 0;top: 0;z-index: -1;" :style="'width:'+w+'px;height:'+h+'px'" src="../static/bg.jpg" alt="">-->
    <router-view/>
<!--    <NavBar v-if="isHome"/>-->
  </div>
</template>

<script>
  // import NavBar from "@/components/navBar";
  export default {
    name: "index", //首页(我的课程)
    data:()=>({
      isHome:false,//是否正在播放音频
      sz:'',
      h:'',
      w:''
    }),
    components: {
      // NavBar,
    },
    mounted(){

    },
    watch:{

    },
  };
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
  outline: 0;
  -webkit-text-size-adjust: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-appearance: none;
  /*消除输入框和按钮的原生外观*/
  font-family: "\5FAE\8F6F\96C5\9ED1";
}
html {
  // font-size: 15.625vw;
  #app {
    width: 100vw;
    min-height: 100vh;
    overflow-x: hidden;
    // background: url("../static/bg.jpg") no-repeat fixed bottom;
    // background-color:#02B4F2;
    /*background:url('../static/bg.jpg') no-repeat left top #02B4F2;*/
    /*background-attachment:fixed*/
  }
}
</style>
